import styled from 'styled-components';
import theme from '../../../config/theme';

const Label = styled.label`
  font-size: ${theme.fonts.sizes.s};
  font-weight: bold;
`;

export default Label;
